import React, { createContext, useContext, useState } from "react";
import { IGalleryImageContext, IGalleryImageData } from "../exports/interfaces";
const GalleryImageContext = createContext<IGalleryImageContext>({
    galleryImageData: [],
    setGalleryImageData: () => null,
  });
  export const useGalleryImageContext = () => useContext(GalleryImageContext);
  
  export const GalleryImageProvider = ({
    children,
  }: {
    children: React.ReactNode;
  }) => {
    const [galleryImageData, setGalleryImageData] = useState<IGalleryImageData[]>([]);
  
    return (
      <GalleryImageContext.Provider value={{ galleryImageData, setGalleryImageData }}>
        {children}
      </GalleryImageContext.Provider>
    );
  };